// Fuzzy Search Library
const Fuse = require('fuse.js')

/**
 * Performs Fuzzy Search on the list of items
 * @param {Array} items - Array of items to perform fuzzy search on
 * @param {String} searchText - The search text
 * @param {Array} keys - Array of string that indicates what property of an item
 * to look at for searching. Example: To do search on item.name put in ["name"]
 * @param {*} options - Additional options
 * @return {Array} - The filtered results after fuzzy search
 */
export function fuzzySearch (items, searchText, keys, options = {}) {
  const defaultOpts = {
    shouldSort: true,
    threshold: 1,
    location: 0,
    distance: 1000,
    maxPatternLength: 50,
    minMatchCharLength: 1
  }
  const fuse = new Fuse(items, { ...defaultOpts, ...options, keys })

  return fuse.search(searchText)
}

/**
 * Returns the fuzzy score. The score indicates how similar the string "str"
 * is to the string "searchText". Score is 0 if the strings match. Score is
 * 1 if the strings are complete mismatch.
 * @param {String} str - The string whose fuzzy score we are looking for
 * @param {String} searchText - The search text
 * @return {Number} - The fuzzy score. The closer to 0 the closer the match. The closer
 * to 1 the farther the match
 */
export function fuzzyScore (str, searchText) {
  const fuse = new Fuse(
    [{ text: str }],
    {
      includeScore: true,
      threshold: 1,
      location: 0,
      distance: 1000,
      maxPatternLength: 50,
      minMatchCharLength: 1,
      keys: ['text']
    }
  )
  const result = fuse.search(searchText)

  if (!result.length) {
    return 1
  }

  return result[0].score
}
